export default __webpack_public_path__ + "static/media/about-img-1.59e2038a.jpg";